<template>
    <div>
        <div
            :class="[
                hasError(errors, 'shipping_address_id')
                    ? 'border-red-600 bg-white'
                    : blacklisted
                      ? 'border-black bg-gray-800'
                      : 'border-gray-200 bg-white',
                'overflow-hidden shadow rounded-lg border',
            ]"
        >
            <div
                :class="[
                    hasError(errors, 'shipping_address_id')
                        ? 'bg-red-500 text-white border-red-600'
                        : blacklisted
                          ? 'bg-gray-900 text-white border-black'
                          : 'bg-gray-100 text-gray-800 border-gray-200',
                    'flex items-center px-4 py-5 sm:px-6 border-b',
                ]"
            >
                <TruckIcon class="h-5 w-5 mr-2" aria-hidden="true" />
                <h2 class="font-bold">Shipping Address</h2>
            </div>

            <div class="px-4 py-3 sm:px-6">
                <div v-if="address">
                    <div
                        :class="[
                            blacklisted ? 'text-white' : 'text-gray-700',
                            'py-3 flex',
                        ]"
                    >
                        <UserIcon
                            class="h-5 w-5 mr-2 shrink-0"
                            aria-hidden="true"
                        />

                        <div>
                            <p>
                                {{ address.name }}
                                <span v-if="blacklisted" class="font-semibold"
                                    >(Blacklisted)</span
                                >
                            </p>
                        </div>
                    </div>

                    <div
                        :class="[
                            blacklisted ? 'text-white' : 'text-gray-700',
                            'py-3 flex',
                        ]"
                    >
                        <LocationMarkerIcon
                            class="h-5 w-5 mr-2 shrink-0"
                            aria-hidden="true"
                        />

                        <div>
                            <p>
                                {{ address.line1 }}
                                <span v-if="address.line2">
                                    <br />
                                    {{ address.line2 }}
                                </span>
                            </p>

                            <p>
                                <span v-if="address.state">
                                    {{ address.city }}, {{ address.state }}
                                    {{ address.postal_code }}
                                </span>

                                <span v-else>
                                    {{ address.city }} {{ address.postal_code }}
                                </span>
                            </p>

                            <p>
                                {{ address.country.name }}
                            </p>
                        </div>
                    </div>

                    <div
                        :class="[
                            blacklisted ? 'text-white' : 'text-gray-700',
                            'py-3 flex',
                        ]"
                    >
                        <MailIcon class="h-5 w-5 mr-2 shrink-0" />

                        <div class="break-all">
                            <p>
                                {{ address.email ? address.email : "(none)" }}
                            </p>
                        </div>
                    </div>

                    <div
                        :class="[
                            blacklisted ? 'text-white' : 'text-gray-700',
                            'py-3 flex',
                        ]"
                    >
                        <PhoneIcon class="h-5 w-5 mr-2 shrink-0" />

                        <div>
                            <p>
                                {{ address.phone ? address.phone : "(none)" }}
                            </p>
                        </div>
                    </div>
                </div>

                <div v-else class="py-3 flex justify-center text-gray-700">
                    <div>
                        <p
                            :class="[
                                hasError(errors, 'shipping_address_id')
                                    ? 'text-red-900'
                                    : 'text-gray-700',
                                'text-center',
                            ]"
                        >
                            {{
                                hasError(errors, "shipping_address_id")
                                    ? error(errors, "shipping_address_id")
                                    : "You haven't added any addresses yet."
                            }}
                        </p>
                    </div>
                </div>

                <ChangeUserCheckoutShippingAddressButton
                    :addresses="addresses"
                    :countries="countries"
                    :csrf="csrf"
                    :emailOptIn="emailOptIn"
                    :errors="errors"
                    :includeVerifyField="includeVerifyField"
                    :initialAddress="address"
                    :initialCountry="country"
                    :initialStates="states"
                    :old="old"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
    LocationMarkerIcon,
    MailIcon,
    PhoneIcon,
    TruckIcon,
    UserIcon,
} from "@heroicons/vue/solid";
import ChangeUserCheckoutShippingAddressButton from "./ChangeUserCheckoutShippingAddressButton.vue";
import { useForm } from "../../functions/useForm";
import { rememberAbandonedCart } from "../../api/cart";

const props = withDefaults(
    defineProps<{
        address?: any;
        addresses?: any;
        canSeeIfAnyAddressIsBlacklisted?: boolean;
        countries?: any;
        country?: any;
        csrf?: string;
        emailOptIn?: string;
        errors?: any;
        includeVerifyField?: boolean;
        initialCountry?: any;
        old?: any;
        states?: any;
    }>(),
    {
        canSeeIfAnyAddressIsBlacklisted: false,
        emailOptIn: "1",
        includeVerifyField: false,
    },
);

const { error, hasError } = useForm();
const blacklisted = computed(
    () =>
        props.canSeeIfAnyAddressIsBlacklisted &&
        props.address &&
        props.address.blacklisted,
);

if (props.address && props.address.email) {
    rememberAbandonedCart({
        name: props.address.name,
        email: props.address.email,
    });
}
</script>
